// extracted by mini-css-extract-plugin
export default {"container":"SuspenseFallback-module__container--lkjVZ","placeholder":"SuspenseFallback-module__placeholder--rtvCC"};